var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.601,
    height: 18.989,
    viewBox: "0 0 22.601 18.989"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-update_svg__cls-1{fill:none;stroke:#009ceb;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-update_svg__ICN_Actualizeaza_Enabled",
    transform: "translate(-1347.866 -495.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-update_svg__Group_724",
    "data-name": "Group 724",
    transform: "translate(1348.997 496.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_87",
    d: "M0 0h1.312",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 87",
    transform: "translate(9.843 2.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Path_832",
    d: "M1.534 4.92S.845.082 5.443 0h3.273",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Path 832",
    transform: "translate(-1.497 2.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_88",
    d: "M0 0h1.312",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 88",
    transform: "translate(13.779 2.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_90",
    d: "M0 0l2.624 2.624",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 90",
    transform: "translate(17.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_91",
    d: "M0 0l2.624 2.624",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 91",
    transform: "rotate(90 8.857 11.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_89",
    d: "M0 0h2.624",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 89",
    transform: "translate(17.714 2.624)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-update_svg__Group_725",
    "data-name": "Group 725",
    transform: "rotate(180 684.668 256.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_87-2",
    d: "M0 0h1.312",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 87",
    transform: "translate(9.843 2.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Path_832-2",
    d: "M.037 4.92S-.652.082 3.945 0h3.274",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Path 832",
    transform: "translate(0 2.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_88-2",
    d: "M0 0h1.312",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 88",
    transform: "translate(13.779 2.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_90-2",
    d: "M0 0l2.624 2.624",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 90",
    transform: "translate(17.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_91-2",
    d: "M0 0l2.624 2.624",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 91",
    transform: "rotate(90 8.857 11.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-update_svg__Line_89-2",
    d: "M0 0h2.624",
    className: "kpmg-update_svg__cls-1",
    "data-name": "Line 89",
    transform: "translate(17.714 2.624)"
  })))));
}

export default SvgKpmgUpdate;